import { Container, Form } from "react-bootstrap";
import "./EconomySwitch.style.css";

const EconomySwitch = (props) => {
  return (
    <Container className="economy-switch-container">
      <div className="economy-switch-div">
        <label title="" className="form-check-label left-label">
          Linearwirtschaft
        </label>
        <Form.Check
          type="switch"
          id="economy-switch"
          label="Kreislaufwirtschaft"
          onChange={props.onChangeEconomySwitch}
          checked={props.circularEconomyState}
        />
      </div>
    </Container>
  );
};

export default EconomySwitch;
